/**
 * Credits are accounted for on the server but hidden from the app until the way Hub is paid for is decided.
 * Flip this to show balances, costs and the credits panel again; the server ledger keeps running either way.
 */
export const CREDITS_VISIBLE = false;
